/**
 * @license Copyright (c) 2014-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import ClassicEditor       from '@ckeditor/ckeditor5-editor-classic/src/classiceditor.js';
import Autoformat          from '@ckeditor/ckeditor5-autoformat/src/autoformat.js';
import BlockQuote          from '@ckeditor/ckeditor5-block-quote/src/blockquote.js';
import Bold                from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Heading             from '@ckeditor/ckeditor5-heading/src/heading.js';
import Image               from '@ckeditor/ckeditor5-image/src/image.js';
import ImageCaption        from '@ckeditor/ckeditor5-image/src/imagecaption.js';
import ImageStyle          from '@ckeditor/ckeditor5-image/src/imagestyle.js';
import ImageToolbar        from '@ckeditor/ckeditor5-image/src/imagetoolbar.js';
import ImageUpload         from '@ckeditor/ckeditor5-image/src/imageupload.js';
import Indent              from '@ckeditor/ckeditor5-indent/src/indent.js';
import Italic              from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
// import Link from 'ckeditor5-custom-link/src/link.js';
import Link                from '@ckeditor/ckeditor5-link/src/link.js';
import List                from '@ckeditor/ckeditor5-list/src/list.js';
import MediaEmbed          from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';
import PasteFromOffice     from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table               from '@ckeditor/ckeditor5-table/src/table.js';
import TableToolbar        from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import ImageResize         from '@ckeditor/ckeditor5-image/src/imageresize.js';
import RemoveFormat        from '@ckeditor/ckeditor5-remove-format/src/removeformat.js';
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter.js';
import Essentials          from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import Paragraph           from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import WordCount           from '@ckeditor/ckeditor5-word-count/src/wordcount';

export default class Editor extends ClassicEditor {}

// Plugins to include in the build.
Editor.builtinPlugins = [
	Autoformat,
	BlockQuote,
	Bold,
	Heading,
	Image,
	ImageCaption,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
	Indent,
	Italic,
	Link,
	List,
	MediaEmbed,
	PasteFromOffice,
	Table,
	TableToolbar,
	ImageResize,
	RemoveFormat,
	SimpleUploadAdapter,
	Essentials,
	Paragraph,
	WordCount
];

Editor.defaultConfig = {
	toolbar : {
		items: [
			'heading',
			'|',
			'bold',
			'italic',
			'link',
			'bulletedList',
			'numberedList',
			'|',
			'indent',
			'outdent',
			'|',
			'imageUpload',
			'blockQuote',
			// 'insertTable',
			'mediaEmbed',
			'undo',
			'redo',
			'|',
			'removeFormat'
		]
	},
	language: 'en',
	image   : {
		toolbar: [
			'imageTextAlternative',
			'imageStyle:full',
			'imageStyle:side'
		]
	},
	// table: {
	// 	contentToolbar: [
	// 		'tableColumn',
	// 		'tableRow',
	// 		'mergeTableCells'
	// 	]
	// },
	heading : {
		options: [
			{
				model            : 'inlineParagraph',
				view             : 'span',
				title            : 'Inline Paragraph',
				class            : 'ck-heading_paragraph_inline',
				converterPriority: 'high'
			},
			{ model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
			{ model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
			{ model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
			{ model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
			{ model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
		]
	}
};
